















import Vue from 'vue';
import RadioButton from '../RadioButton/RadioButton.vue';

export default Vue.extend({
  name: 'RadioButtonGroup',
  props: {
    value: {
      required: true,
    },
    options: {
      type: Array, // Object.entries(), map of [[value, label], ..]
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RadioButton,
  },
});
